module.exports = __webpack_public_path__ + "ba.06c220dbf9f7d6a25c36.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/ba.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/ba.svg
// module chunks = styles